<template>
    <!-- {dragging ? <div className="w-full h-screen fixed z-0 inset-0 bg-gray-800 opacity-80"></div> : null} -->
    <div :class='dragging ? `${className} ${activeClass}` : `${className} ${inactiveClass}`'
        @dragover={onDragOver}
        @dragleave={onDragLeave}
        @drop={onDrop}
        :id="$el.id">
        <slot />
    </div>
</template>

<script>
export default {
    props: ['className', 'activeClass', 'inactiveClass'],

    emits: ['onDropEvent','onDragStart','onDragEnd'],

    data() {
        return {
            dragging: false
        }
    },

    methods: {
        onDrop: function (e) {
            e.preventDefault()

            this.dragging = false
            console.log('File(s) dropped');

            this.$emit('onDropEvent', e.dataTransfer.files);
        },

        onDragOver: function (e) {
            e.preventDefault()
            if (dragging) {
                return;
            }

            this.$emit('onDragStart', e)
            this.dragging = true

            console.log('File(s) in drop zone');
            // console.log(e)
        },

        onDragLeave: function (e) {
            e.preventDefault()
            this.$emit('onDragEnd', true);
            this.dragging = false
        },
    },
}
</script>
